<template>
    <div class="l-ss-c-completions-brand">
        <div class="l-ss-c-completions-brand-header">
            <span class="l-ss-c-completions-brand-title">{{ $t('completions.category.brands') }}</span>
            <!--            <div-->
            <!--                class="l-ss-c-completions-brand-controls"-->
            <!--                v-show="showControls">-->
            <!--                <button-->
            <!--                    class="l-ss-c-completions-brand-control"-->
            <!--                    @click="scrollToLeft">-->
            <!--                    <i v-html="arrowIcon"></i>-->
            <!--                </button>-->
            <!--                <button-->
            <!--                    class="l-ss-c-completions-brand-control"-->
            <!--                    @click="scrollToRight">-->
            <!--                    <i v-html="arrowIcon"></i>-->
            <!--                </button>-->
            <!--            </div>-->
        </div>

        <div
            class="l-ss-c-completions-brand-list"
            :style="isMobile ? { 'padding-bottom': '6px' } : null"
            ref="brandsList">
            <div
                class="l-ss-c-completions-brand-items-wrapper"
                ref="brandItemsWrapper">
                <a
                    class="l-ss-c-completions-brand-item"
                    v-for="(brand, i) in brands"
                    :key="i"
                    :href="brand.url"
                    :data-id="brand._id"
                    :data-position="i + 1"
                    v-html="brand.text.html">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import arrowRight from '@/core/assets/images/icons/arrow-right.svg';

    // Const SCROLL_OFFSET = 200;

    export default {
        props: {
            brands: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                resizeObserver: null,
                showControls: false,
            };
        },
        computed: {
            arrowIcon() {
                return arrowRight;
            },

            isMobile() {
                return this.$screen.isMobile;
            },
        },
        watch: {
            brands() {
                this.$nextTick(() => {
                    // This.calcIsShowControls();
                });
            },
        },
        mounted() {
            /*
             * This.initResizeObserver();
             * this.calcIsShowControls();
             */
        },
        beforeDestroy() {
            // This.resizeObserver.unobserve(this.$refs.brandsList);
        },
        methods: {
            initResizeObserver() {
                /*
                 * This.resizeObserver = new ResizeObserver(this.calcIsShowControls);
                 * this.resizeObserver.observe(this.$refs.brandsList);
                 */
            },
            calcIsShowControls() {
                if (this.isMobile) {
                    return false;
                }

                let brandItemsWidth = this.$refs.brandItemsWrapper.clientWidth;
                this.showControls = brandItemsWidth > this.$refs.brandsList.clientWidth;
            },
            scrollToRight() {
                // This.$refs.brandsList.scrollBy({ top: 0, left: SCROLL_OFFSET, behavior: 'smooth' });
            },
            scrollToLeft() {
                // This.$refs.brandsList.scrollBy({ top: 0, left: -SCROLL_OFFSET, behavior: 'smooth' });
            },
        },

    };
</script>
